(ns frontend.view.components.timeline.entry.meeting-log
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.db :as db]
            [common.localization :as loc]
            [clojure.string :as string]
            [frontend.state.current-session :as session]))

(defn comment-text [text]
  (if (string/blank? text)
    (loc/tr :none)
    (->> text
         (take db/timeline-comment-length)
         (string/join ""))))

(defn who [{:keys [person/first-name person/last-name]}]
  (str first-name " " last-name))

(defn target-text [entity]
  (case (:entity/type entity)
    :entity.type/oppo (->> entity :oppo/name vector (loc/tr :meeting-deal))
    :entity.type/company (->> entity :asset/name vector (loc/tr :meeting-company))
    ""))

(defn title-generator [entry]
  (let [target (->> entry
                    :audit/target-changes
                    :meeting/target
                    :set)
        target-text (target-text target)
        meeting-text (->> entry
                          :audit/target
                          (get @session/entities)
                          :meeting/text
                          comment-text
                          vector
                          (loc/tr :meeting-text))
        person (->> entry
                    :audit/target-changes
                    :meeting/person
                    :set
                    who
                    vector
                    (loc/tr :meeting-with))
        {:keys [change-text!]} entry]
    [:span
     (str target-text person meeting-text)
     [:i.fal.fa-pencil.edit-icon
      {:on-click (fn [e]
                   (.preventDefault e)
                   (.stopPropagation e)
                   (change-text!))}]]))

(defmethod te/timeline-entry-view :op.meeting/log [{entry :entry}]
  [default/timeline-item-view entry title-generator default/body-generator])
